import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { Button } from '../components/Button';
import { ApproachSection } from '../components/ApproachSection';
import { EmployerCta } from '../components/EmployerCta';
import { services } from '../data/services';
export function Services() {
  return <>
      <PageHeader label="Services" title="Recruitment services built around your hiring needs." intro="From confidential executive search to focused sourcing support, each engagement is shaped around the role, the team, and the experience you need." actions={<>
            <Button to="/employers#enquiry" data-id="element-444" data-mp="64y9yheg1lk2">Discuss a Role</Button>
            <Button to="/contact" variant="outline" data-id="element-445" data-mp="65r8ww75v6rn">
              Contact Us
            </Button>
          </>} data-id="element-443" data-mp="3ji1ec7gin0mu" />

      <section aria-label="Our services" className="bg-white py-20 lg:py-28" data-id="element-446" data-mp="27wb5ifuiuh3g">
        <ul className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-447" data-mp="27yfjjqm4wwhg">
          {services.map(({
          title,
          detail,
          suitedTo,
          icon: Icon
        }, i) => <li key={title} className="border-b border-ink/10 py-12 first:pt-0 last:border-b-0 lg:py-16" data-id="element-448" data-mp="1bnnvsbo0odpx" data-mpi={i}>
              <Reveal delay={i * 0.04} className="grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-449" data-mp="1fozerycdy0p5">
                <div className="lg:col-span-4" data-id="element-450" data-mp="1kfzefbcw2wvc">
                  <Icon size={32} strokeWidth={1.1} className="text-navy" aria-hidden="true" data-id="element-451" data-mp="1khsn0w72br5z" />
                  <h2 className="mt-6 font-serif text-3xl font-medium leading-tight text-navy sm:text-[34px]" data-id="element-452" data-mp="1pesosuwvq7ra">
                    {title}
                  </h2>
                </div>
                <p className="text-lg leading-relaxed text-ink/75 lg:col-span-5" data-id="element-453" data-mp="1zejiwvhj2kqu">{detail}</p>
                <div className="lg:col-span-3" data-id="element-454" data-mp="23e25rwswt5wb">
                  <p className="text-sm font-medium text-ink" data-id="element-455" data-mp="23cr3y2j0y87u">Often suited to</p>
                  <ul className="mt-3 space-y-2.5" data-id="element-456" data-mp="51a72x1ien5f">
                    {suitedTo.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-ink/75" data-id="element-457" data-mp="91cbhdympuoe">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-458" data-mp="1cc89nhfisupn" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </Reveal>
            </li>)}
        </ul>
      </section>

      <div className="border-t border-ink/10" data-id="element-459" data-mp="1hd5s7v4fzqro">
        <ApproachSection data-id="element-460" data-mp="1va2erkdj2m2r" />
      </div>
      <EmployerCta data-id="element-461" data-mp="1v8zrrnjbt3s4" />
    </>;
}